import React from 'react'
import { Typography } from '@material-ui/core'

export default function AboutUs() {
    return (
        <>
           <Typography variant="h6" component="p" paragraph>
               We at Nadeem Tarin are providing the facility to the residents to manage their dining account with the help of 
               this web application created by students of B.Tech(Computer Engineering) as part of their Minor Project.
               At this site you may check the status of your account, pay the due, request the food at your room, and open/close your Dining
               account.
               You may check on the food menu and also suggest your opinion.  
            </Typography>
            {/* <Typography variant="h6" component="p" paragraph>
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
                A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text  A lot of text 
            </Typography> */}
                {/* <label for="exampleFormControlTextarea1" className="form-label">Example textarea</label>
                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea> */}
      
        </>
    )
}
